<template>
  <div>
    <div v-if="!typeDeep">
      <van-swipe :autoplay="5000" class="cardss">
        <van-swipe-item  v-for="item in typeList" :key="item.id">
          <img :src="$store.state.baseUrl + item.img" />
          <div class="rights" @click="jumpToType(item)">{{$store.state.languageType === 1?'点击进入':'Click to enter'}}</div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div v-if="typeDeep">
      <div class="cards" v-for="item in byIdTypeList" :key="item.id">
        <div class="tops">
          <img :src="$store.state.baseUrl + item.thumbImg" alt="" />
        </div>
        <div class="bottoms">
          <div class="lefts">{{ item.name }}</div>
          <div class="rights" @click="jumpToDetail(item)">{{$store.state.languageType === 1?'详情':'detail'}}</div>
        </div>
      </div>
    </div>
    <div class="back_icon" @click="back"></div>
  </div>
</template>

<script>
import { GetAllSpecialType, GetSpecialByType } from "../api/home.api";
export default {
  data() {
    return {
      typeList: [],
      typeDeep: false,
      typeId: null,
      byIdTypeList: [],
      language: null,
    };
  },
  created() {
    this.language = JSON.parse(JSON.stringify(this.$store.state.languageType));
    this.getALLType();
  },
  components: {},
  methods: {
    // 获得所有的专题类型
    async getALLType() {
      let { data: res } = await GetAllSpecialType({
        languageType: this.language,
      });
      if (res.code === 0) {
        this.typeList = res.data;
      }
    },
    // 点击后进入对应类型详情
    jumpToType(e) {
      this.typeDeep = true;
      this.typeId = e.id;
      this.getListByType(this.typeId);
    },
    // 进入详情
    jumpToDetail(e) {
      sessionStorage.setItem("lineshow", JSON.stringify(false));
      sessionStorage.setItem("special", true);
      this.$router.push({
        path: "/detail",
        query: {
          id: e.id,
          lineshow: false,
          special: true,
        },
      });
    },
    async getListByType(e) {
      let { data: res } = await GetSpecialByType({
        type: e,
        language: this.$store.state.languageType,
      });
      this.byIdTypeList = res.data;
    },
    back() {
      if (this.typeDeep) {
        this.typeDeep = false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.back_icon {
  background-image: url("../../static/Group 313@2x.png");
  background-size: 100% 100%;
  width: 3rem;
  height: 3rem;
  position: fixed;
  right: 0.5rem;
  bottom: 2rem;
  z-index: 99999;
}
.cardss{
  margin: 5vh 5vw;
  width: 90vw;
  height: 80vh;
  background: #fff;
  box-shadow: 0 0 5px 0 #eee;
  border-radius: 0.5rem;
  ::v-deep .van-swipe-item{
    position: relative;
    img{
      display: block;
      width: 100% !important;
      height: 100% !important;
    }
    .rights{
      position: relative;
      left: 50%;
      bottom: 20%;
      width: 30vw;
      text-align: center;
      transform: translate(-50%);
       background-color: #45d48a;
      border-radius: 0.5rem;
      color: #fff;
      padding: 1vh 3vw;
      z-index: 99999;
    }
  }
  
}

.cards {
  margin-left: 5vw;
  margin-top: 2vh;
  width: 90vw;
  height: 30vh;
  background: #fff;
  box-shadow: 0 0 5px 0 #eee;
  border-radius: 0.5rem;
  .tops {
    height: 22vh;
    width: 100%;

    img {
      display: block;
      width: 100% !important;
      height: 100% !important;
      border-radius: 0.3rem;
    }
  }

  .bottoms {
    padding-top: 2vh;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 80vw;
    height: 4vh;
    margin: 0 auto;
    .lefts {
    }

    .rights {
      background-color: #45d48a;
      border-radius: 0.5rem;
      color: #fff;
      padding: 1vh 3vw;
    }
  }
}
</style>